import React from 'react';
import ControlGrid from './components/ControlGrid';
import RubigramTopBar from './components/RubigramTopBar';
import { RubigramStore } from './RubigramStore';
import PauseCover from '../shared/PauseCover';
import { PuzzleNames } from '../../../utils/types';
import { useAmplitudeTracking, useFirstTimeInstructions, useIsMobileDimensions, usePageVisibilityPause, useStructuredDataEmbedding } from '../shared/utils';
import { saveRubigram } from './rubigramUtils';
import { usePuzzleTracking } from '../../../utils/usePuzzleTracking';
import './Rubigram.less';

const Rubigram = () => {
  const { revealed, solved } = RubigramStore.useState();

  useFirstTimeInstructions(PuzzleNames.Rubigram, RubigramStore as any);
  usePageVisibilityPause(RubigramStore as any, saveRubigram);
  useStructuredDataEmbedding(PuzzleNames.Rubigram);
  useAmplitudeTracking(PuzzleNames.Rubigram);
  usePuzzleTracking(PuzzleNames.Rubigram);

  return (
    <>
      <RubigramTopBar/>
      <div className={`puzzleContainer rubigramContainer ${solved ? 'solved' : ''}`}>
        <ControlGrid/>
        {revealed &&
          <div className="outcomeBanner">
            Solution revealed. Try again tomorrow!
          </div>
        }
        {solved &&
          <div className="outcomeBanner">
            Solved! New puzzle tomorrow.
          </div>
        }
        <PauseCover store={RubigramStore as any}/>
      </div>
    </>
  );
};

export default Rubigram;